import { render, staticRenderFns } from "./ProductInquiryForm.vue?vue&type=template&id=64591c38&scoped=true"
import script from "./ProductInquiryForm.vue?vue&type=script&lang=js"
export * from "./ProductInquiryForm.vue?vue&type=script&lang=js"
import style0 from "./ProductInquiryForm.vue?vue&type=style&index=0&id=64591c38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64591c38",
  null
  
)

export default component.exports